var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('vue-qr',{attrs:{"text":_vm.qrText,"callback":_vm.handleQrGenerated,"size":200,"margin":10}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }